import { SSO_MODELS } from "@r-and-a-shared-ui/common-kontent-client";
import { getMappedItem } from "./component-mapping-helpers";
import { VWRConfiguration } from "../../models";
import { getCookie, redirectTo, VWR_REFERRER } from "@r-and-a-shared-ui/utils";

export const getMappedVWRConfig = (vwrConfig?: SSO_MODELS.VirtualWaitingRoomConfiguration) => {
  return getMappedItem<
    SSO_MODELS.VirtualWaitingRoomConfiguration | undefined,
    VWRConfiguration
  >(vwrConfig);
};

export const handleVWRCacheBrowserNavigation = () => {
  try {
    window.addEventListener('pageshow', (event) => {
      if(!event.persisted) {
        return;
      }
      const referrer = getCookie(VWR_REFERRER);
      if(referrer) {
        redirectTo(decodeURIComponent(referrer));
        return;
      }
      window.history.go(-1);
    });
  }
  catch(error) {
    console.log(error);
  }
};